module.exports = __webpack_public_path__ + "static/media/diners.43cbbcfd.svg";